export const RbacBadge = {
  tag: 'span',
  text: (el, s) => s.role || 'Admin',
  fontSize: 'Y',
  fontWeight: '600',
  padding: 'X Z',
  round: 'C',
  background: (el, s) => {
    const r = s.role || 'Admin'
    if (r === 'Admin') return 'gold.15'
    if (r === 'Doctor') return 'teal.15'
    if (r === 'Hygienist') return 'purple'
    if (r === 'Receptionist') return 'blue.15'
    if (r === 'LabTech') return 'amber.15'
    if (r === 'Patient') return 'inkSurface'
    return 'inkSurface'
  },
  color: (el, s) => {
    const r = s.role || 'Admin'
    if (r === 'Admin') return 'inkText'
    if (r === 'Doctor') return 'ink'
    if (r === 'Hygienist') return 'white'
    if (r === 'Receptionist') return 'ink'
    if (r === 'LabTech') return 'ink'
    if (r === 'Patient') return 'inkMuted'
    return 'inkMuted'
  }
}
